import { Component, Input } from '@angular/core';
import { ContentService } from '../../services/content/content.service';

const content = require('./competence-list.content.json');

@Component({
  selector: 'app-competence-list',
  templateUrl: './competence-list.component.html',
  styleUrls: ['./competence-list.component.scss']
})
export class CompetenceListComponent {
  @Input()
  public set selectedCluster(selectedCluster: any) {
    if (!selectedCluster) {
      return;
    }
    this._selectedCluster = selectedCluster;
    if (this._selectedCluster.competentiesLeft) {
      this._selectedCluster.competentiesLeft = this._selectedCluster.competentiesLeft.map(item => {
        return {
          ...item,
          label: this.getScaleForCompetence(item)
        };
      });
    }
    if (this._selectedCluster.competentiesRight) {
      this._selectedCluster.competentiesRight = this._selectedCluster.competentiesRight.map(item => {
        return {
          ...item,
          label: this.getScaleForCompetence(item)
        };
      });
    }
  }

  @Input()
  descriptionContent: string

  public _selectedCluster: any;

  public constructor(private contentService: ContentService) {
    this.contentService.loadContent(content);
  }

  private getScaleForCompetence(competence: any): string {
    if (competence.gewicht >= 0 && competence.gewicht <= 13) {
      return 'basis';
    }
    if (competence.gewicht > 13 && competence.gewicht <= 39) {
      return 'gemiddeld';
    }
    if (competence.gewicht > 39 && competence.gewicht <= 71) {
      return 'gevorderd';
    }
    if (competence.gewicht > 71 && competence.gewicht <= 100) {
      return 'expert';
    }
  }
}
